import { isMotionValue } from './basler-components.es820.js';

function isWillChangeMotionValue(value) {
    return Boolean(isMotionValue(value) && value.add);
}

export { isWillChangeMotionValue };
